// Events
import { COLLECTION_PRODUCT_FOCUSED, PRODUCT_ITEM_QUICK_SHOP_TOGGLE } from 'events';
// Lib
import Tracking from 'lib/tracking';
import { component } from 'picoapp';
import { clearQueueScrollLocks, disablePageScroll, enablePageScroll } from 'scroll-lock';

// Utils
import choozy from 'utils/choozy';

export default component((node, ctx) => {
  const {
    imageWrapper,
    quickShopModal,
    quickShopToggle,
    productItemQuickAddForm: productItemQuickAddForms,
    quickShopCartSelect,
    quickShopCartSubmit,
    carousel,
    hasInfoModal,
  } = choozy(node);
  const { template } = node.dataset;

  const toggleModal = (opened, cartUpdated, { isMobile } = window.theme) => {
    if (opened) {
      node.removeAttribute('open');
      quickShopModal.removeAttribute('open');
      setTimeout(() => {
        quickShopModal.setAttribute('hidden', '');
        imageWrapper.insertAdjacentElement('beforeend', quickShopModal);

        if (isMobile) {
          document.dispatchEvent(new Event('disable-auto-close-trigger-close'));
        }
      }, 300);

      if (cartUpdated) {
        node.classList.add('product-added');
      }

      enablePageScroll();
    } else {
      document.querySelectorAll('.product-item[open]').forEach((productItem) => {
        ctx.emit(PRODUCT_ITEM_QUICK_SHOP_TOGGLE, { productItem });
      });

      if (isMobile) {
        document.body.insertAdjacentElement('beforeend', quickShopModal);

        document.dispatchEvent(new Event('disable-auto-close-trigger-open'));

        clearQueueScrollLocks();
        disablePageScroll();
      }

      quickShopModal.removeAttribute('hidden');
      setTimeout(() => {
        node.setAttribute('open', '');
        quickShopModal.setAttribute('open', '');
      }, 0);

      if (template === 'collection') {
        window.scrollTo({
          top: isMobile ? node.offsetTop - 72 : node.offsetTop - 89,
          left: 0,
          behavior: 'smooth',
        });

        setTimeout(() => {
          ctx.emit(COLLECTION_PRODUCT_FOCUSED, { show: false });
        }, 500);
      }
    }
  };

  if (imageWrapper && quickShopModal && quickShopToggle) {
    quickShopToggle.forEach((modalToggle) =>
      modalToggle.addEventListener('click', toggleModal(quickShopModal.hasAttribute('open'))),
    );

    ctx.on(PRODUCT_ITEM_QUICK_SHOP_TOGGLE, ({ productItem, cartUpdated }) => {
      if (productItem === node) toggleModal(quickShopModal.hasAttribute('open'), cartUpdated);
    });
  }

  node.addEventListener('click', (event) =>
    Tracking.selectItemCallback(event, !!carousel, !hasInfoModal),
  );

  if (quickShopModal)
    quickShopModal.addEventListener('product-item:quick-shop:select-variant', (event) => {
      event.stopPropagation();

      Array.from(productItemQuickAddForms).forEach((productItemQuickAddForm) => {
        if (event.currentTarget !== productItemQuickAddForm)
          productItemQuickAddForm.dispatchEvent(
            new CustomEvent('product-item:quick-shop:select-variant', {
              detail: event.detail,
              bubbles: false,
            }),
          );
      });
    });

  if (quickShopCartSelect)
    quickShopCartSelect.addEventListener('change', () => {
      quickShopCartSubmit.removeAttribute('disabled');
    });

  node.addEventListener('product:form:submit', () => {
    toggleModal(quickShopModal.hasAttribute('open'));
  });
});
